import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, ViewContainerRef } from '@angular/core';
import { MapApi } from '../../../api/map-api';
import { ESRI } from '../../../esri-loader-util';
import { LayerService } from '../../../services/layer.service';
import { MapService } from '../../../services/map.service';
import { BaseComponent } from '../../base.component';
// geographic center of PA
var centerLatitude = 40.875;
var centerLongitude = -77.802783;
var zoomLevel = 5;
var Graphic;
var GraphicsLayer;
var Map;
var MapView;
var Point;
var Polygon;
var SimpleFillSymbol;
/** Overview Map Component - Displays an ESRI map overview of the Commonwealth of PA */
var OverviewMapComponent = /** @class */ (function (_super) {
    tslib_1.__extends(OverviewMapComponent, _super);
    function OverviewMapComponent(vcr, mapApi, layerService, mapService) {
        var _this = _super.call(this, vcr) || this;
        _this.mapApi = mapApi;
        _this.layerService = layerService;
        _this.mapService = mapService;
        _this.zoom = zoomLevel;
        _this.center = [centerLongitude, centerLatitude];
        _this.basemap = 'streets-vector';
        _this.cancelEvent = function (event) {
            event.stopPropagation();
        };
        return _this;
    }
    OverviewMapComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, parent_1, err_1;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 7, 8, 9]);
                        return [4 /*yield*/, Promise.all([
                                ESRI.Graphic,
                                ESRI.GraphicsLayer,
                                ESRI.MCMap,
                                ESRI.MCMapView,
                                ESRI.Point,
                                ESRI.Polygon,
                                ESRI.SimpleFill
                            ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 7]), Graphic = _a[0], GraphicsLayer = _a[1], Map = _a[2], MapView = _a[3], Point = _a[4], Polygon = _a[5], SimpleFillSymbol = _a[6];
                        this.map = Map({ basemap: this.basemap });
                        _b = this;
                        return [4 /*yield*/, MapView({
                                center: this.center,
                                container: this.mapAreaRef.nativeElement,
                                map: this.map,
                                zoom: this.zoom
                            }, this.mapId, this.mapApi, this.layerService)];
                    case 2:
                        _b.mapView = _c.sent();
                        this.mapView.constraints = {
                            rotationEnabled: false
                        };
                        this.mapView.on('key-down', function (event) {
                            var prohibitedKeys = ['+', '-', 'Shift', '_', '='];
                            var keyPressed = event.key;
                            if (prohibitedKeys.indexOf(keyPressed) !== -1) {
                                event.stopPropagation();
                            }
                        });
                        this.mapView.on('mouse-wheel', this.cancelEvent);
                        this.mapView.on('double-click', this.cancelEvent);
                        this.mapView.on('double-click', ['Control'], this.cancelEvent);
                        this.mapView.on('drag', this.cancelEvent);
                        this.mapView.on('drag', ['Shift'], this.cancelEvent);
                        this.mapView.on('drag', ['Shift', 'Control'], this.cancelEvent);
                        this.mapView.on('click', function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                this.mainMapView.goTo({ center: new Point({ latitude: event.mapPoint.latitude, longitude: event.mapPoint.longitude }) });
                                event.stopPropagation();
                                return [2 /*return*/];
                            });
                        }); });
                        this.extentLayer = new GraphicsLayer();
                        this.map.add(this.extentLayer);
                        this.mapService.mcOverviewMapView = this.mapView;
                        if (!!this.mainMapView) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.getClosestAncestor('mc-map')];
                    case 3:
                        parent_1 = _c.sent();
                        if (!parent_1) return [3 /*break*/, 5];
                        return [4 /*yield*/, parent_1.ready];
                    case 4:
                        _c.sent();
                        this.mainMapView = parent_1.mapView;
                        return [3 /*break*/, 6];
                    case 5:
                        this.readyProblem('Map View Reference not supplied and reference from parent element could not be retrieved.');
                        _c.label = 6;
                    case 6:
                        this.mainMapView.watch('extent', function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var polygon, extentGraphic;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!this.mainMapView) {
                                            return [2 /*return*/];
                                        }
                                        if (!this.mainMapView.extent) return [3 /*break*/, 2];
                                        this.extentLayer.graphics.removeAll();
                                        return [4 /*yield*/, this.getPolygonFromExtent(this.mainMapView.extent)];
                                    case 1:
                                        polygon = _a.sent();
                                        extentGraphic = new Graphic({
                                            geometry: polygon,
                                            symbol: new SimpleFillSymbol({
                                                style: 'solid',
                                                color: [248, 217, 28, 0.1],
                                                outline: {
                                                    color: [255, 0, 0, 1],
                                                    width: 1
                                                }
                                            })
                                        });
                                        this.extentLayer.add(extentGraphic);
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [3 /*break*/, 9];
                    case 7:
                        err_1 = _c.sent();
                        this.readyProblem(err_1);
                        throw err_1;
                    case 8:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    OverviewMapComponent.prototype.getPolygonFromExtent = function (extent) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var polygon;
            return tslib_1.__generator(this, function (_a) {
                polygon = new Polygon({
                    spatialReference: extent.spatialReference
                });
                polygon.addRing([
                    [extent.xmin, extent.ymin],
                    [extent.xmin, extent.ymax],
                    [extent.xmax, extent.ymax],
                    [extent.xmax, extent.ymin],
                    [extent.xmin, extent.ymin]
                ]);
                return [2 /*return*/, polygon];
            });
        });
    };
    return OverviewMapComponent;
}(BaseComponent));
export { OverviewMapComponent };
